import { render, staticRenderFns } from "./OrganisationUnitDetails.vue?vue&type=template&id=3a58a440&scoped=true&"
import script from "./OrganisationUnitDetails.vue?vue&type=script&lang=js&"
export * from "./OrganisationUnitDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a58a440",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
